import { Space as AntdSpace } from "@empglabs/backoffice-ui-kit"

const Space = props => {
  return <AntdSpace {...props} />
}

export default Space
